import { useEffect, useState } from "react";

const SCRIPT_ID = "ld-faq";

// Injects a Schema.org FAQPage JSON-LD into the document head, so Google
// can show FAQ entries as rich snippets in search results.
export default function useFAQSchema(items) {
  useEffect(() => {
    if (!items || items.length === 0) return;
    const data = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map((f) => ({
        "@type": "Question",
        name: f.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: f.answer,
        },
      })),
    };
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) existing.remove();
    const el = document.createElement("script");
    el.id = SCRIPT_ID;
    el.type = "application/ld+json";
    el.textContent = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      const cur = document.getElementById(SCRIPT_ID);
      if (cur) cur.remove();
    };
  }, [items]);
}
